import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@draeger-academy/common';
import { TranslateModule } from '@ngx-translate/core';
import { DaButtonModule } from '../da-button';
import { DaLinkModule } from '../da-link';
import { LinkListBoxComponent } from './link-list-box.component';

@NgModule({
    declarations: [LinkListBoxComponent],
    imports: [CommonModule, PipesModule, DaLinkModule, DaButtonModule, TranslateModule],
    exports: [LinkListBoxComponent]
})
export class LinkListBoxModule {}
